import type { ReactNode } from "react";

type Props = {
  label?: string;
  value?: ReactNode;
  img?: string;
  children?: ReactNode;
};

export default function Info({ label, value, img, children }: Props) {
  return (
    <div>
      {!!label && (
        <h6 className="text-theme-slate-400 text-sm font-normal">{label}</h6>
      )}
      {!!value && (
        <div className="text-theme-neutral-800 text-sm font-medium font-roboto">
          {value}
        </div>
      )}
      {!!img && (
        <a
          href={img}
          target="_blank"
          rel="noopener noreferrer"
          className="text-theme-blue-600 text-sm font-medium"
        >
          {img.length > 25 ? `${img.slice(0, 12)}...${img.slice(-12)}` : img}
        </a>
      )}
      {children}
    </div>
  );
}
